import { useState } from 'react'
import { MaintainerModal } from '@/presentation/common/components/maintainer/MaintainerModal.tsx'
import { SidebarButton } from '@/presentation/common/components/SidebarButton.tsx'
import { useCrudAuth } from '@/presentation/common/hooks/crud/useCrudAuth.ts'
import { useActionsModal } from '@/presentation/common/hooks/useActionsModal.ts'
import { useMaintainerStore } from '@/presentation/common/store/zustand/maintainer.ts'
import { CreatePayStateResumeForm } from '@/presentation/payStates/forms/CreatePayStateResumeForm.tsx'
import { DeletePayStateResumeForm } from '@/presentation/payStates/forms/DeletePayStateResumeForm.tsx'
import { UpdatePayStateResumeForm } from '@/presentation/payStates/forms/UpdatePayStateResumeForm.tsx'
import { usePayStatePreviewStore } from '@/presentation/payStates/store/preview.ts'

export const PayStateResumeActions = () => {
  const { data } = usePayStatePreviewStore()
  const selectionCount = useMaintainerStore((state) => state.selectionCountV2())

  const { canCreate, canUpdate, canDelete } = useCrudAuth()
  const { open, setOpen } = useActionsModal()
  const [ option, setOption ] = useState<'POST' | 'PUT' | 'DELETE' | null>(null)

  const isPost = option === 'POST'
  const isPut = option === 'PUT'
  const isDelete = option === 'DELETE'

  const title = isPost ? 'Añadir Registro al Resumen' : isPut ? 'Actualizar Registro del Resumen' : 'Eliminar selección'

  const closeModal = () => {
    setOpen(false)
    setOption(null)
  }

  const onFinish = () => {
    closeModal()
  }

  return (
    <>
      <MaintainerModal title={title} open={open}>
        {isPost && <CreatePayStateResumeForm onCancel={closeModal} onFinish={onFinish}/>}
        {isPut && <UpdatePayStateResumeForm onCancel={closeModal} onFinish={onFinish}/>}
        {isDelete && <DeletePayStateResumeForm onCancel={closeModal} onFinish={onFinish}/>}
      </MaintainerModal>

      {canCreate && !!data && (
        <SidebarButton label="Añadir Reg. Resumen" type="POST" onClick={() => {
          setOption('POST')
          setOpen(true)
        }}/>
      )}

      {canUpdate && (
        <SidebarButton label="Actualizar Reg. Resumen" type="PUT" onClick={() => {
          setOption('PUT')
          setOpen(true)
        }}/>
      )}

      {canDelete && (
        <SidebarButton label={`Eliminar selección (${selectionCount})`} type="DELETE" onClick={() => {
          setOption('DELETE')
          setOpen(true)
        }}/>
      )}
    </>
  )
}
